import $ from 'jquery';
import {Module} from '../plugins/_application';
import {debounce} from '../utils/debounce';
import {animate, createTimeline, stagger} from 'animejs';
import Barba from 'barba.js';

/*
 -------------------------------
 Class
 -------------------------------
 */

export default class Navigation extends Module {
	ready () {
		/**
		 * Responsive Nav
		 */
		let navIcon = $('.nav_icon');
		let nav = $('nav#main_nav');
		let navItem = $('#menu-main-menu>li a');
		let body = $('body');
		let navBreakpoint = 1100;

		/**
		 * Navigation animation timeline
		 */
		let navTimeline = createTimeline({
			autoplay: false,
			// Handle the visibility of the navigation
			onUpdate: function (anim) {
				if(anim.began === true && nav.css('visibility') === 'hidden') {
					nav.css('visibility', 'visible');
				} else if (anim.progress === 0 && anim.reversed) {
					nav.css('visibility', 'hidden');
					$('.menu-item-has-children').removeClass('menu-open');
				}
			}
		});

		navTimeline
			.add('nav#main_nav', {
				translateX: ['-100%', 0],
				ease: 'inOutSine',
				duration: 300
			})
			.add('#menu-main-menu>li>a', {
				translateX: [-150, 0],
				duration: 600,
				ease: 'outElastic(1, .4)',
				delay: stagger(50)
			}, 150);

		// JS object to handle the navigation
		let navigation = {
			init: function () {
				nav.css('transform', '');
				navItem.css('transform', '');

				let dropdownElement = document.createElement('div');
				$(dropdownElement).prependTo('.menu-item-has-children').addClass('dropdown-arrow');
			},
			openNav: function () {
				navIcon.addClass('open');
				body.addClass('no-scroll');
				nav.addClass('has-opened');
				navTimeline.play();
			},
			closeNav: function () {
				$('li.menu-item').removeClass('menu-open');
				navIcon.removeClass('open');
				body.removeClass('no-scroll');
				navTimeline.play();
				navTimeline.reverse();
			},
			toggleNav: function () {
				if (nav.css('visibility') === 'visible') {
					navigation.closeNav();
				} else if (nav.css('visibility') === 'hidden') {
					navTimeline.restart();
					navigation.openNav();
				}
			},
			scrolled: function () {
				let windowWidth = $(window).width();
				if (windowWidth > navBreakpoint) {
					let offset = $(window).scrollTop();
					let header = $('header#main_header');
					let scrolledClass = 'scrolled';
	
					if(offset > 50) {
						header.addClass(scrolledClass);
					} else {
						header.removeClass(scrolledClass);
					}
				} else if (windowWidth <= 600 && $('body').hasClass('admin-bar')) {
					let offset = $(window).scrollTop();
					let header = $('header#main_header');

					if(offset >= 40) {
						header.css('top', 0);
					} else {
						header.css('top', 46);
					}
				}
			},
			resizeHandler: debounce(function () {
				if ($(window).width() > navBreakpoint) {
					$(document).off('click touchend', '.dropdown-arrow');
					$('.menu-item-has-children').removeClass('menu-open');

					if (nav.hasClass('has-opened')) {
						nav.css('visibility', '');
						nav.css('transform', '');
						navItem.css('transform', '');
						navIcon.removeClass('open');
					}
				} else if ($(window).width() <= navBreakpoint) {
					$(document).on('click touchend', '.dropdown-arrow', mobileNavigation.toggleDropdown);

					$('header#main_header').removeClass('scrolled');
					$('.sub-menu li').removeClass('menu-open');
				}
			}, 300)
		}

		/**
		 * Mobile navigation
		 */
		let mobileNavigation = {
			toggleDropdown: function (e) {
				e.preventDefault();

				if ($(window).width() <= navBreakpoint) {
					let menuItem = $(this).parent();
					menuItem.toggleClass('menu-open');

					let subMenuNavigation = animate($(this).parent().children().children().children('a').get(), {
						autoplay: false,
						translateX: [-250, 0],
						ease: 'outElastic(1, .4)',
						duration: 600,
						delay: stagger(50)
					})

					if(menuItem.hasClass('menu-open')) {
						subMenuNavigation.play();
					} else {
						$(this).parent().find('.sub-menu li').removeClass('menu-open');
						$(this).parent().find('.sub-menu li a').css('transform', 'translateX(-250px)');
					}
				}
			},
			clickLink: function (e) {
				if ($(window).width() <= navBreakpoint) {
					e.preventDefault();

					let emptyLink = $(this).attr("href") === '#';
	
					if (!emptyLink) {
						if ($('.nav_icon').hasClass('open')) {
							navigation.toggleNav();
						}

						let url = $(this)[0].href;

						if (url != undefined && url.indexOf("/produkt/") > -1) {
							window.location.replace(url)
						}

					}
				}
			}
		}

		/**
		 * Initialize navigation
		 */
		navigation.init();

		/**
		 * Event listeners
		 */
		$('.nav_icon').on('click', navigation.toggleNav);
		$(window).on('resize', navigation.resizeHandler);
		$(window).on('scroll', navigation.scrolled);
		$(document).on('click', '#main_nav a', mobileNavigation.clickLink);
		$(document).on('click', '.menu-item-has-children a[href*="#"]', mobileNavigation.toggleDropdown);

		Barba.Dispatcher.on('linkClicked', function() {
			if ($(window).width() < navBreakpoint) {
				if ($('.nav_icon').hasClass('open')) {
					navigation.toggleNav();
				}
			}
		});

		if ($(window).width() > navBreakpoint) {
			$(document).on('click', '.sub-menu .dropdown-arrow', mobileNavigation.toggleDropdown);
		} else {
			$(document).on('click', '.dropdown-arrow', mobileNavigation.toggleDropdown);
		}

		let curHover = false;

		$('#main_nav').find('#menu-main-menu').find('.menu-item-has-children').mouseenter(function(){

			if($(window).width() > 1100){

				const THIS_ID = $(this).attr('class').split('_')[1];

				$('#blog-menu').find('#menu-hover-menu').find('li').each(function(){
					curHover = true;
					var thisObj = $(this),
						childId = thisObj.attr('class').split('_')[1];
						
					if(childId === THIS_ID){

						$('#blog-menu').addClass('show');

						changeBlogMenuTab();

						const THIS_HEIGHT = $(thisObj).outerHeight();
						$('#menu-hover-menu').css('height', THIS_HEIGHT+'px');

						thisObj.addClass('active');
					}
				});

			}

		});

		$('#main_nav').find('#menu-main-menu').find('.menu-item-object-category').mouseleave(function(){

			curHover = false;

			if ($('#blog-menu:hover').length == 0 && $('#menu-item-195:hover').length == 0 && $('#menu-item-196:hover').length == 0) {

				closeBlogMenu();

			}

		});

		$('#blog-menu').mouseleave(function(){
			curHover = false;
			if($('#menu-item-195:hover').length == 0 && $('#menu-item-196:hover').length == 0) {
				closeBlogMenu();
			}
		});

		function changeBlogMenuTab(){
			$('#blog-menu').find('#menu-hover-menu').find('.active').removeClass('active');
		}

		function closeBlogMenu() {
			// setTimeout(function(){
			// 	if(curHover == false){
			// 		$('#blog-menu').css({
			// 			'opacity': '0',
			// 			'visibility': 'hidden',
			// 			'transform': 'translateY(-100%)'
			// 		});
			// 	}
			// }, 100);
			// setTimeout(function(){
				if(curHover == false){
					$('#blog-menu').removeClass('show');
					$('#blog-menu').removeAttr('style');

					$('#blog-menu').find('#menu-hover-menu').find('.active').removeClass('active');
				}
			// }, 400);
		}
	}
}